import { render, staticRenderFns } from "./VueBadge.vue?vue&type=template&id=cf9ce99e&scoped=true&"
import script from "./VueBadge.vue?vue&type=script&lang=js&"
export * from "./VueBadge.vue?vue&type=script&lang=js&"
import style0 from "./VueBadge.vue?vue&type=style&index=0&id=cf9ce99e&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "cf9ce99e",
  null
  
)

export default component.exports